import { z } from 'zod'
import { Category, Manufacturer, Unit } from './products'
import { shortageSchema } from './schemas'

export type NewShortage = z.infer<typeof shortageSchema>

export type UpdateShortage = NewShortage & {
  id: string
}

export enum ShortageStatus {
  NEW = 'NEW',
  ORDERED = 'ORDERED',
  FULFILLED = 'FULFILLED',
  UNFULFILLED = 'UNFULFILLED',
}

export type Shortage = Omit<NewShortage, 'productId'> & {
  id: string
  createdAt: string
  orderedAt: string | null
  fulfilledAt: string | null
  product: {
    id: string
    symbol: string
  }
  status: ShortageStatus
  shortageOrderId: string | null
  createdById: string
}

export type ShortageTableItem = Omit<Shortage, 'createdAt' | 'orderedAt' | 'fulfilledAt'> & {
  createdAt: Date
  orderedAt: Date | null
  fulfilledAt: Date | null
}

export type GroupedShortage = {
  product: {
    id: string
    symbol: string
  }
  feature?: string | null
  size: string
  category: Category
  manufacturer: Manufacturer | null
  subRows: Array<Shortage>
}

export type GroupedShortageTableItem = Omit<GroupedShortage, 'subRows'> & {
  subRows: Array<ShortageTableItem>
}

export type ShortageOrder = {
  id: string
  createdAt: string
  fulfilledAt: string | null
  shortageAmount: number
  orderedAmount: number
  fulfilledAmount: number | null
  unit: Unit
  product: {
    id: string
    symbol: string
  }
  feature: string | null
  size: string
  category: Category
  manufacturer: Manufacturer | null
  isEmailSent: boolean
  createdById: string
}

export type ShortageOrderTableItem = Omit<ShortageOrder, 'createdAt' | 'fulfilledAt'> & {
  createdAt: Date
  fulfilledAt: Date | null
}

export type NewShortageOrder = {
  productId: string
  feature?: string | null
  size: string
  category: Category
  orderedAmount: number
  unit: Unit
}

export type UpdateShortageOrder = {
  id: string
  fulfilledAt?: Date | null
  orderedAmount?: number
  fulfilledAmount?: number | null
  isEmailSent?: boolean
}
